'use strict';

/* globals define, config */

define('courseCreator', [
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	var CourseCreator = {};

	CourseCreator.init = function (course, translations) {
		initChaptersVueApp({
			chapters: course.chapters,
			translations: translations,
		});

		initTrainersVueApp({
			trainers: course.trainers,
			translations: translations,
		});

		initFilesVueApp({
			files: course.files,
			translations: translations,
		});
	};

	function initChaptersVueApp(initData) {
		new Vue({
			el: '#course-creator',
			data: {
				initData: initData,
			},
		});
	}

	function initTrainersVueApp(initData) {
		new Vue({
			el: '#trainers-creator',
			data: {
				initData: initData,
			},
		});
	}

	function initFilesVueApp(initData) {
		new Vue({
			el: '#files-creator',
			data: {
				initData: initData,
			},
		});
	}

	return CourseCreator;
});
